// frontend/src/ActivityLog/dateRange.js — pure helpers for the Activity page's date-range filter.
// Dates are local calendar days as "YYYY-MM-DD", the same strings the ?since= and ?until= filters carry.

const pad = (n) => String(n).padStart(2, '0');

export const toYmd = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export function fromYmd(s) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s || '')) return null;
  const date = new Date(Number(s.slice(0, 4)), Number(s.slice(5, 7)) - 1, Number(s.slice(8, 10)));
  return Number.isNaN(date.getTime()) ? null : date;
}

export const PRESETS = [['today', 'Today'], ['yesterday', 'Yesterday'], ['last7', 'Last 7 days'], ['last30', 'Last 30 days'], ['month', 'This month']];

const daysAgo = (today, n) => new Date(today.getFullYear(), today.getMonth(), today.getDate() - n);

// A preset's range, counted back from `today` (inclusive of today, except Yesterday).
export function presetRange(key, today = new Date()) {
  const until = toYmd(today);
  switch (key) {
    case 'today': return { since: until, until };
    case 'yesterday': { const y = toYmd(daysAgo(today, 1)); return { since: y, until: y }; }
    case 'last7': return { since: toYmd(daysAgo(today, 6)), until };
    case 'last30': return { since: toYmd(daysAgo(today, 29)), until };
    case 'month': return { since: toYmd(new Date(today.getFullYear(), today.getMonth(), 1)), until };
    default: return { since: '', until: '' };
  }
}

const fmt = (date, withYear) => date.toLocaleDateString('en-US', withYear ? { month: 'short', day: 'numeric', year: 'numeric' } : { month: 'short', day: 'numeric' });

// What the filter button says: "Any time", one day, or a range (the year once when both ends share it).
export function rangeLabel(since, until) {
  const a = fromYmd(since); const b = fromYmd(until);
  if (!a && !b) return 'Any time';
  if (a && !b) return `Since ${fmt(a, true)}`;
  if (!a && b) return `Until ${fmt(b, true)}`;
  if (since === until) return fmt(a, true);
  return a.getFullYear() === b.getFullYear() ? `${fmt(a, false)} – ${fmt(b, true)}` : `${fmt(a, true)} – ${fmt(b, true)}`;
}
